import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseServices } from 'src/app/kuba/kuba.services';
import { Rights } from 'src/app/_models';

@Component({
  selector: 'app-othersystem-list',
  templateUrl: './othersystem-list.component.html',
  standalone: false
})
export class OthersystemListComponent implements OnInit {

  isOtherSystemRights = true; 
  hideOtherSystemRights= true;

  constructor(private router: Router, private route: ActivatedRoute) { 
  }

  ngOnInit(): void {
      document.querySelector("body").classList.remove("opened");
      /*
       * get InternalControl list
       */
      
      if (+BaseServices.roleId === 4) {
          this.isOtherSystemRights = false;
          this.router.navigate(['own'], { relativeTo: this.route });
      } else if (+BaseServices.roleId === 5) {
          this.onOtherSystemRights();
      } else {
        this.OnAdmin();
      }      
  }

  onOtherSystemRights() {
      let currentUserRole = BaseServices.UserRole;
      let userRightsId = Rights.ADMINISTRATE_OTHER_SYSTEMS;

      if (currentUserRole === 'User') {
          this.isOtherSystemRights = BaseServices.checkUserRights(userRightsId, currentUserRole);
          this.router.navigate(['own'], { relativeTo: this.route });
      } else {
          this.isOtherSystemRights = true;
          this.router.navigate(['all'], { relativeTo: this.route });
      }
  }
  OnAdmin(){
    let curSession = JSON.parse(sessionStorage.getItem('RModeBusinessId'));
    if(curSession > 0)
    {
        this.isOtherSystemRights=true;
        this.hideOtherSystemRights = false;
        this.router.navigate(['all'], { relativeTo: this.route  });
    }
    else{
        this.isOtherSystemRights = true;
        this.router.navigate(['all'], { relativeTo: this.route  });
    }
}

}
